import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './core/providers/guards/auth.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  private translate = inject(TranslateService);
  private authService = inject(AuthService);
  isHighlighted = false;

  ngOnInit(): void {
    this.authService.helpModalTrigger$.subscribe(res => {
      this.isHighlighted = res;
    });
    const savedLang = sessionStorage.getItem('lang') || 'en';
    this.translate.use(savedLang);
  }



  closeModal(): void {
    this.authService.clearHelpHighlight();
  }
}
